import { render, staticRenderFns } from "./ValidatedField.vue?vue&type=template&id=2b6abb44&scoped=true&lang=pug"
import script from "./ValidatedField.vue?vue&type=script&lang=js"
export * from "./ValidatedField.vue?vue&type=script&lang=js"
import style0 from "./ValidatedField.vue?vue&type=style&index=0&id=2b6abb44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6abb44",
  null
  
)

export default component.exports